// Core data types shared across multiple components
export enum SCMProviderType {
  Git = "git",
  GithubApp = "github_app",
  GithubCodeAccessApp = "github_code_access_app",
  GithubEnterpriseApp = "github_enterprise_app", // Added in to support Restricted GitHub app
}

export interface RepositorySelectionEventDetail {
  repository: RepositoryInfo | null;
  scmService: SCMServiceInfo | null;
}

export enum RepositoryURLType {
  SSH = "ssh_url",
  HTTPS = "clone_url",
}

export type SCMServiceInfo = {
  uuid: string;
  repositories_url: string;
  provider_type: SCMProviderType;
  account_login: string;
  has_code_access: boolean;
  avatar_url?: string;
  repositories?: RepositoryInfo[]; // Pre-loaded repositories for instant filtering
  is_default?: boolean; // Indicates if this is the default selected service
};

export const isGitHubService = (service: SCMServiceInfo | null): boolean => {
  return (
    service?.provider_type === SCMProviderType.GithubApp ||
    service?.provider_type === SCMProviderType.GithubCodeAccessApp
  );
};

export const isRestrictedAppService = (service: SCMServiceInfo | null): boolean => {
  // TODO: ensure this isn't confused with other 'normal' GHES Apps
  return service?.provider_type === SCMProviderType.GithubEnterpriseApp;
};

export type RepositoryInfo = {
  full_name: string;
  description: string;
  private: boolean;
  fork: boolean;
  language: string | null | undefined;
  html_url: string;
  ssh_url: string;
  clone_url: string;
  default_branch: string;
  visibility: "public" | "private" | "internal";
  updated_at: string;
  is_default?: boolean; // Indicates if this is the default selected repository
  configuration?: string;
};

export type ParsedRepositoryUrl = {
  name: string;
  url: string;
  detected_provider: ManualProviderType;
  url_type: RepositoryURLType;
};

export type ManualProviderType = "git" | "gitlab" | "bitbucket";
